// src/CoPilotChat.jsx
import React, { useEffect, useState, useRef, useMemo, use } from "react";
import { Container, Card, Form, Row, Col,Button } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import AskIT from "../images/AskIT.png";
import FusionHubLogo from "../images/logoFusion.png";
import Arrow from "./Arrow";
import { studentInfoApi } from "../api/studentInfoAPI";
import { FaExclamationTriangle } from 'react-icons/fa'
import { FaCaretRight } from "react-icons/fa";
import ModalForAnnounce from "./ModalForAnnounce";


// Ensure WebChat is available globally if using CDN
// You would typically include this in your public/index.html
// <script src="https://cdn.botframework.com/botframework-webchat/latest/webchat.js"></script>

/*using node server */
//const DIRECT_LINE_TOKEN_ENDPOINT = 'http://localhost:3001/api/directline/token'; // Your backend endpoint



/*INTEGRATION
const DIRECT_LINE_TOKEN_ENDPOINT =
  "https://api.houstonisd.org/AskITChatTokenServiceINT/api/directline/token"; 
*/

/*PRODUCTION 
const DIRECT_LINE_TOKEN_ENDPOINT =
  "https://api.houstonisd.org/ChatBotTokenService/api/directline/token";
  */

  /*AZURE -DEV*/
const DIRECT_LINE_TOKEN_ENDPOINT =
  "https://api-askit-dev.azurewebsites.net/api/AskIT/token";

const CoPilotChat = ({
  userId = "YourCustomUserID_React",
  userName = "React User",
}) => {
  const [directLineToken, setDirectLineToken] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const webChatRef = useRef(null);

  const [isArrowVisible, setArrowVisible] = useState(true);
  const hasHiddenArrow = useRef(false); // <-- ADD THIS LINE
  const [message, setMessage] = useState("Waiting...");

  const [sMsgOneVisible, setMsgOneVisible]  = useState([]); 
  const [sMsgTwoVisible, setMsgTwoVisible]  = useState([]); 
  const [sMsgThreeVisible, setMsgThreeVisible]   = useState([]);  

  const [sMsgFourMessage, setMsgFourMessage]   = useState([]);  


  const [DefaultMessageVisible, setDefaultMessageVisible]   = useState([]); 
  const [SystemMessageVisible, setSystemMessageVisible]    = useState([]); 
  const [locale, setLocale] = useState("en-US"); // Add this state

  const [showModalAnnounce, setshowModalAnnounce] = useState(false);

  
  useEffect(() => {
    
    const timer = setTimeout(() => {
      setMessage("Time's up! Executing next line...");
      determineDefaultMessageVisibility();
      fetchITNews();
    }, 400); // 2-second delay

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);
  

   /*DETERMINE DEFAULT MESSAGE VISIBILTY*/
  const determineDefaultMessageVisibility = async() => {
    var myAPI = new studentInfoApi();
    var bool = await myAPI.determineAlerts()
    console.log("Alert Status: " + bool);
    if (bool) {
      setSystemMessageVisible('block');
      setDefaultMessageVisible('none');
      setMessages();
    } else {
       setSystemMessageVisible('none');
       setDefaultMessageVisible('block');
    }
  }

  const setMessages = async() => {
    await fetchMessageDataNetwork();
    await fetchMessageDataEmail();
    await fetchMessageDataSIS();
  }


  var statusMessageNetwork = "";
  const fetchMessageDataNetwork = async () => {
    var myAPI = new studentInfoApi();
    statusMessageNetwork = await myAPI.fetchMessageDataNetwork();
    const editor = document.getElementById("editor");
    if (statusMessageNetwork[0].Message === "") {
      setMsgOneVisible('none');
    }
    console.log(statusMessageNetwork[0].Message + ' - Posted on  ' + statusMessageNetwork[0].TimeStamp);
    editor.innerHTML = statusMessageNetwork[0].Message + ' - Posted on  ' + statusMessageNetwork[0].TimeStamp;
  };

  var statusMessageEmail = "";
  const fetchMessageDataEmail = async () => {
    var myAPI = new studentInfoApi();
    statusMessageEmail = await myAPI.fetchMessageDataEmail();
    const editor = document.getElementById("editor2");
      if (statusMessageEmail[0].Message === "") {
      setMsgTwoVisible('none');
     }
    editor.innerHTML = statusMessageEmail[0].Message+ ' - Posted on  ' + statusMessageEmail[0].TimeStamp;
  };

  var statusMessageSIS = "";
  const fetchMessageDataSIS = async () => {
    var myAPI = new studentInfoApi();
    statusMessageSIS = await myAPI.fetchMessageDataSIS();
    const editor = document.getElementById("editor3");
      if (statusMessageSIS[0].Message === "") {
      setMsgThreeVisible('none');
    }
    editor.innerHTML = statusMessageSIS[0].Message+ ' - Posted on   ' + statusMessageSIS[0].TimeStamp;
  };

  var statusMessageITNEWS = "";
  const fetchITNews = async () => {
    var myAPI = new studentInfoApi();
    statusMessageITNEWS = await myAPI.fetchITNews();
    const editor = document.getElementById("editor4");
    if (statusMessageITNEWS[0].Message === "") {
      setMsgFourMessage('none');
    }
    else {
     //setMsgFourMessage(statusMessageITNEWS[0].Message+ ' - Posted on  ' + statusMessageITNEWS[0].TimeStamp);
     setMsgFourMessage(statusMessageITNEWS[0].Message);
    }
    //editor.innerHTML = statusMessageITNEWS[0].Message+ ' - Posted on   ' + statusMessageITNEWS[0].TimeStamp;
    
  };
  
  
 

  
  useEffect(() => {
    
    const fetchToken = async () => {
      try {
        const response = await fetch(DIRECT_LINE_TOKEN_ENDPOINT, {
          method: "POST",
        });
        if (!response.ok)
          throw new Error(
            `Failed to fetch Direct Line token: ${response.status}`
          );
        const data = await response.json();
        setDirectLineToken(data.token);
        setIsLoading(false);
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
      }
    };
    fetchToken();
    
  }, []);

 

  const directLine = useMemo(
    () =>
      directLineToken
        ? window.WebChat.createDirectLine({ token: directLineToken })
        : null,
    [directLineToken]
  );

  

   const store = useMemo(() => {
    if (!window.WebChat) return null;

    return window.WebChat.createStore(
      {}, // initial state
      ({ dispatch }) => (next) => (action) => {
        // This is the middleware where we can "spy" on actions
        
         //console.log('Web Chat Action:', action);

        // This action fires every time the text in the send box changes
        if (action.type === 'WEB_CHAT/SET_SEND_BOX') {
          // We only want to hide the arrow the VERY FIRST time the user types
          if (action.payload.text.length > 0 && !hasHiddenArrow.current) {

            // ==========================================================
            // == THIS IS THE FIX: Use a functional update ==
            // ==========================================================
            
            setArrowVisible(_ => false);

            // Set our ref flag so this code never runs again
            hasHiddenArrow.current = true;
          }
        }

          
        
         // Alternative "Redirect" method
        if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
            dispatch({
                type: 'WEB_CHAT/SEND_POST_BACK',
                payload: {
                    value: '__INTERNAL_START_CONVERSATION__' // The secret trigger phrase
                }
            });
        }

          // Pass the action along so Web Chat continues to work normally
          return next(action);
      }
    );
  }, []); // The dependency array can remain empty



 

  useEffect(() => {
    
    if (directLine && store && webChatRef.current && window.WebChat) {
      window.WebChat.renderWebChat(
        {
          directLine,
          store,
          userID: userId,
          username: userName,
          locale: "en-US",
          styleOptions: {
            botAvatarInitials: "CP",
            userAvatarInitials: userName
              ? userName.substring(0, 1).toUpperCase()
              : "U",
            bubbleBackground: "#f0f0f0",
            bubbleFromUserBackground: "#d1eaff",
            suggestedActionBackground: "white",
          },
        },
        webChatRef.current
      );
    }
    
  }, [directLine, store, userId, userName]);
  // --- End of unchanged logic ---
  


  
  if (isLoading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        Loading Chat...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ color: "red", padding: "20px", textAlign: "center" }}>
        Error: {error}. Please ensure the backend token server is running.
      </div>
    );
  }



    const handleResetClick = () => {
        // We have access to the 'store' variable from our useMemo hook.
        // We just dispatch the action directly. This is what `usePostBack`
        // would have done for us under the hood.
        if (store) {
            console.log("Reset button clicked. Dispatching postback action...");
            store.dispatch({
                type: 'WEB_CHAT/SEND_POST_BACK',
                payload: {
                    value: '__INTERNAL_START_CONVERSATION__'
                }
            });
        } else {
            console.error("Store not available to dispatch action.");
        }
    };

    const handleShowAnnouncementClick = () => {
      setshowModalAnnounce(true);
    };
    
    // In your select onChange handler
const handleLocaleChange = (e) => {
  const newLocale = e.target.value;
  console.log("Locale changed to:", newLocale);
  setLocale(newLocale);
  //document.getElementById('btnResetChat').click(); // Reset chat on locale change
  
  /* Dispatch locale change to the store*/
  if (store) {
    store.dispatch({
      type: 'WEB_CHAT/SET_LANGUAGE',
      payload: { language: newLocale }
    });
  }
    
};

 const closeModalPrimaryAnnounce = () => {
    setshowModalAnnounce(false);
  };

  return (
    <Container
      fluid
      className="py-3 py-md-4"
      style={{ backgroundColor: "transparent" }}
    >
      <Card style={{ backgroundColor: "#0d6881", border: "none" }}>
        <Form>
          <Row className="m-0 position-relative">
            {/* --- Left Column: Branding --- */}
            {/*text-white d-flex flex-column justify-content-center text-center text-md-start p-4 p-lg-5*/}
            <Col
              xs={12}
              md={4}
              className="text-white d-flex flex-column justify-content-start text-center text-md-start p-4 p-lg-5 "
            >
              <div
                className="radio-canada-font"
                style={{ display: "flex", alignItems: "flex-start", gap: "12px", fontSize: "1.2rem", lineHeight: "1.5" }}
              >
                <Image
                  src={AskIT}
                  style={{ width: "100px", height: "100px", flexShrink: 0 }}
                />
                <p style={{ margin: 0 }}>
                  Hi there! I'm AskIT. I'm here to help with your technical
                  concerns, from hardware issues to application questions.
                  <br /><br />
                  NOTE:{" "}
                  <i>
                    To restart the chat conversation click the Restart button
                    below at any time.
                  </i>
                </p>
              </div>

              <div style={{ textAlign: "center", margin: "0.75rem 0" }}>
                <Button
                  variant="info"
                  onClick={handleResetClick}
                  style={{
                    width: "150px",
                    backgroundColor: "#006f5b",
                    color: "white",
                    fontSize: "16px",
                    borderColor: "white",
                    borderBlockStyle: "double",
                  }}
                >
                  Restart
                </Button>
              </div>

              <hr style={{ borderColor: "rgba(255,255,255,0.4)", margin: "0.5rem 0 1rem 0" }} />

              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  borderTop: "5px solid #3ee0c2",
                  padding: "16px",
                  marginTop: "0.5rem",
                  marginBottom: "1rem",
                  color: "#1a1a1a",
                }}
              >
                <div style={{ textAlign: "center", marginBottom: "12px" }}>
                  <Image src={FusionHubLogo} style={{ maxWidth: "200px", height: "auto" }} />
                </div>

                <p style={{ fontSize: "0.95rem", lineHeight: "1.6", marginBottom: "12px" }}>
                  If you are having trouble logging into FusionHub, please click the button below to watch a brief video.
                </p>

                <a
                  href="https://houstonisd.sharepoint.com/SolutionCenter/_layouts/15/stream.aspx?id=%2FSolutionCenter%2FSiteAssets%2FSitePages%2FFusion%2DHub%2Ffusionhub%2Dgeneral%2Dnavigation%2Dv3%2Emp4&nav=eyJwbGF5YmFja09wdGlvbnMiOnsic3RhcnRUaW1lSW5TZWNvbmRzIjo2My42MDE3NjR9fQ%3D%3D&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview%2E8e03a741%2Dbd6b%2D4aeb%2D9591%2D4d5ce64c3de8"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    style={{
                      marginBottom: "12px",
                      width: "100%",
                      backgroundColor: "white",
                      color: "#0d6881",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderColor: "#0d6881",
                      borderWidth: "2px",
                    }}
                  >
                    <i className="fas fa-play-circle" style={{ marginRight: "8px" }} />
                    How to Login into FusionHub
                  </Button>
                </a>

                <p style={{ fontSize: "0.95rem", lineHeight: "1.6", marginBottom: "0" }}>
                  If you watched the video above, but still need assistance with FusionHub access, please click the FusionHub button in chat window to the right and follow the onscreen instructions to get assistance.
                </p>
              </div>

              <p
                style={{
                  fontSize: "1.2rem",
                  fontFamily: "sans-serif",
                  lineHeight: "1.5",
                  display: "none",
                }}
              >
                We'd love to hear about your experience today.
                <a
                  href="https://apps.powerapps.com/play/e/default-f5eb9966-9336-4b33-8895-9982425b13ed/a/000264b4-5538-486a-a448-2d4fd4590757?tenantId=f5eb9966-9336-4b33-8895-9982425b13ed&hint=cc954f50-ae68-4b58-bfab-f4d573eb6e37&sourcetime=1749577570570"
                  target="blank"
                  style={{ color: "white" }}
                >
                  <br></br>
                  👉[Click here to fill out the short survey]
                </a>
              </p>

              <br></br>
              <Button
                variant="info"
                onClick={handleShowAnnouncementClick}
                style={{
                  marginBottom: "1rem",
                  width: "500px",
                  backgroundColor: "#006f5b",
                  color: "white",
                  fontSize: "25px",
                  borderColor: "white",
                  borderBlockStyle: "double",
                  display: "none",
                }}
              >
                <i
                  className="fas fa-bullhorn"
                  style={{ marginRight: "8px", color: "white" }}
                ></i>
                Click here for Announcements
              </Button>

              <Form.Group className="mb-3">
                <div
                  className="text-center"
                  style={{
                    border: "1px solid white",
                    padding: "5px",
                    borderRadius: "5px",
                    marginBottom: "0px",
                    width: "100%",
                  }}
                >
                  {" "}
                  {/* Add this div with text-center */}
                  <Form.Label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "25px",
                      fontWeight: "bold",
                    }}
                  >
                    <i
                      className="fas fa-bullhorn"
                      style={{ marginRight: "8px", color: "white" }}
                    ></i>
                    IT News
                  </Form.Label>
                </div>
                {/*}
                <Form.Control
                  as="textarea"
                  rows={7}
                  id="editor4"
                  style={{
                    marginBottom: "1rem",
                    width: "550px",

                    backgroundColor: "#3ee0c2",
                    color: "black",
                    fontSize: "15px",
                  }}
                  value={sMsgFourMessage}
                  readOnly
                />
                */}
               
                    <div
                      style={{
                        /* Apply styling that matches the textarea's appearance from the image */
                        marginBottom: "1rem",
                        width: "100%",
                        height: "170px",
                        overflowY: "auto", // Enable vertical scrolling if content overflows
                        backgroundColor: "#3ee0c2",
                        color: "black",
                        fontSize: "15px",
                        padding: '8px', // Add some padding to simulate the textarea
                        whiteSpace: 'pre-wrap', // To respect line breaks/spaces if needed
                        border: '1px solid #ced4da' // Standard form control border
                      }}
                      // THIS is the key to rendering raw HTML content
                      dangerouslySetInnerHTML={{ __html: sMsgFourMessage }}
                    />
              </Form.Group>
            </Col>

            {/* --- Right Column: Chat Interface --- */}
            <Col xs={12} md={8} className="p-3 p-md-4 d-flex flex-column">
              {/*  ********THIS IS NOT BEING SHOWN - THE DISPLAY: "NONE" *******/}
              <div
                id="welcome-text"
                style={{
                  color: "black",
                  fontFamily: "Segoe UI",
                  fontSize: "14px",
                  backgroundColor: "#ebf5fb",
                  padding: "20px",
                  borderRadius: "8px",
                  marginBottom: "1rem",
                  display: DefaultMessageVisible,
                }}
              >
                <strong style={{ fontSize: "20px" }}>
                  Welcome to AskIT! Your HISD Virtual Service Agent
                </strong>
                <hr />
                <p style={{ marginBottom: "1px" }}>
                  Need help? Just follow the directions in the chat window
                  below!
                  <br />
                  <i>Need a do-over? No worries! </i> Click the 'Restart' button
                  on the left, or type{" "}
                  <span style={{ color: "#39ac39", fontWeight: "bold" }}>
                    RESTART
                  </span>{" "}
                  below at any time.
                </p>
              </div>
              {/*  END OF********THIS IS NOT BEING SHOWN - THE DISPLAY: "NONE" *******/}

              <div
                id="alert-text"
                style={{
                  color: "black",
                  fontFamily: "Segoe UI",
                  fontSize: "14px",
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  marginBottom: "1rem",
                  display: SystemMessageVisible,
                  boxShadow: "-5px 5px  #e70b0bff",
                }}
              >
                <span style={{ fontSize: "16px" }}>
                  <span style={{ fontWeight: "bold", color: "red" }}>
                    <FaExclamationTriangle
                      style={{
                        color: "#d65113ff", // Yellow color for warning
                        marginRight: "8px", // Space to the text
                        verticalAlign: "middle", // Align icon with text vertically
                        fontSize: "15px", // Inherit font size or set specific size
                        //border: "2px solid black",
                      }}
                      size="18px" // Or use fontSize in style if you prefer
                    />
                    SYSTEM ALERTS!
                  </span>{" "}
                  Please review the alerts below before submitting a support
                  ticket. Your issue may already be known and being addressed.
                </span>

                <hr />

                <div
                  id="messageArea"
                  style={{
                    display: sMsgOneVisible,
                    backgroundColor: "#f1b4b4ff",
                    marginBottom: "5px",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  <i class="fa-solid fa-play"></i>{" "}
                  <span
                    id="editor"
                    style={{ fontSize: "14px", color: "#721d03ff" }}
                  >
                    {" "}
                  </span>
                </div>

                <div
                  id="messageArea2"
                  style={{
                    display: sMsgTwoVisible,
                    backgroundColor: "#f1b4b4ff",
                    marginBottom: "5px",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  <i class="fa-solid fa-play"></i>{" "}
                  <span
                    id="editor2"
                    style={{ fontSize: "14px", color: "#721d03ff" }}
                  >
                    {" "}
                  </span>
                </div>

                <div
                  id="messageArea3"
                  style={{
                    display: sMsgThreeVisible,
                    backgroundColor: "#f1b4b4ff",
                    marginBottom: "5px",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  <i class="fa-solid fa-play"></i>{" "}
                  <span
                    id="editor3"
                    style={{ fontSize: "14px", color: "#721d03ff" }}
                  >
                    {" "}
                  </span>
                </div>
              </div>

              {/* Chatbot Wrapper */}
              <div className="chatbot-wrapper">
                <div
                  id="webchat-react-container"
                  style={{
                    height: "50vh", // <-- THIS IS THE KEY CHANGE
                    minHeight: "450px",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "white",
                    borderRadius: "8px",
                    // flexGrow: 1, // <-- REMOVED THIS
                  }}
                >
                 <span id="languageSection" style={{display:'none'}}>
                  <span
                    style={{
                      marginLeft: "10px",
                      marginTop: "5px",
                      fontSize: "15px",
                    }}
                  >
                    Select language then <b>click restart button</b>:
                  </span>
                  <span
                    style={{
                      marginLeft: "10px",
                      marginTop: "5px",
                      fontSize: "15px",
                    }}
                  >
                    Seleccione el idioma entonces haga{" "}
                    <b>clic en el boton de reinicio</b>:
                  </span>
                  <br></br>

                  <select
                    onChange={handleLocaleChange}
                    value={locale}
                    style={{
                      fontSize: "16px",
                      backgroundColor: "#e0e0e0",
                      marginLeft: "10px",
                      marginBottom: "10px",
                      width: "200px",
                      borderRadius: "5px",
                      padding: "5px",
                    }}
                  >
                    <option value="en-US">English</option>
                    <option value="es-US">Español</option>
                  </select>
                  <hr></hr>
                </span>
                  <div
                    ref={webChatRef}
                    style={{
                      flexGrow: 1,
                      overflowY: "auto",
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>

      <Form>
        <Row>
          <Col sm={12}>
            <ModalForAnnounce
              actionLabel=""
              title="HISD Announcements"
              showPrimaryModal={showModalAnnounce}
              close="Close"
              Submit="Place Holder"
              handleClosePrimary={() => closeModalPrimaryAnnounce}
            />
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default CoPilotChat;
